<ng-container *ngIf="handles$ | async"></ng-container>
<ng-container *ngIf="groups$ | async"></ng-container>

<div mat-dialog-title>
  <span class="title dialog-title" i18n>Ручки</span>
  <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- MENU -->
<div class="px-4 py-2 flex flex-row justify-between">
  <mat-form-field appearance="outline" class="dense-input no-subscript flex-1">
    <input data-testid="handlesSearchInput" matInput #filter placeholder="Поиск" i18n-placeholder />
    <button data-testid="handlesSearchButton" matSuffix mat-icon-button #filterButton>
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>
</div>
<!-- MENU END -->

<mat-divider> </mat-divider>

<div mat-dialog-content class="no-padding ps">
  <as-split direction="horizontal" [unit]="'pixel'">
    <as-split-area [size]="320">
      <csl-group-matrial-tree
        [groupMaterials]="groups"
        class="ps"
        [focusedGroupId]="focusedGroupId"
        (selectedGroupChange)="onSelectGroup($event)"></csl-group-matrial-tree>
    </as-split-area>

    <as-split-area cslPerfectScrollbar>
      <mat-table #table [dataSource]="dataSource" class="material-list-table">
        <!-- Select Column -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let item">
            <mat-checkbox
              data-testid="handlesSelectionCheckbox"
              [ngModel]="isSelected(item)"
              (change)="toggleSelection(item)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- Texture Column -->
        <ng-container matColumnDef="texture">
          <mat-header-cell *matHeaderCellDef i18n>Текстура</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <ng-container *ngIf="!item.textureName && item.color; then showColor; else showTexture"> </ng-container>
            <ng-template #showColor>
              <div class="mw-texture mw-color" [ngStyle]="{ 'background-color': '#' + item.color }"></div>
            </ng-template>
            <ng-template #showTexture>
              <img
                (click)="openTextureViewerDialog(item.textureLink)"
                class="mw-texture"
                src="{{ item.cropTextureLink }}" />
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- Butt Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef i18n>Наименование</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <p
              #buttName
              [matTooltip]="item.name"
              [matTooltipDisabled]="!showFullNameTooltip(buttName)"
              class="text-truncate h6 p-1">
              {{ item.name }}
            </p>
          </mat-cell>
        </ng-container>

        <!-- Article Column -->
        <ng-container matColumnDef="article">
          <mat-header-cell *matHeaderCellDef i18n>Артикул</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <p
              #buttArticle
              [matTooltip]="item.article"
              [matTooltipDisabled]="!showFullNameTooltip(buttArticle)"
              class="text-truncate h6 p-1">
              {{ item.article }}
            </p>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          class="material-list-row"
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ selected: isSelected(row) }"></mat-row>
      </mat-table>

      <div class="flex flex-row justify-center">
        <button
          class="m-32"
          color="accent"
          *ngIf="hasMore && !loading"
          (click)="loadMore$.next([loadMore$.value[0] + 1, loadMore$.value[1]])"
          mat-stroked-button
          i18n
          >Загрузить еще</button
        >
        <mat-spinner *ngIf="loading" class="m-32" [diameter]="16"> </mat-spinner>
      </div>
    </as-split-area>
  </as-split>
</div>

<div mat-dialog-actions>
  <button mat-raised-button data-testid="handlesSaveButton" class="mat-accent" (click)="saveAndClose()" i18n>ОК</button>
  <button mat-button (click)="dialogRef.close(undefined)" i18n>ОТМЕНА</button>
</div>
